const META_NAME = 'app-build-id'
const UPDATE_ATTEMPT_KEY = 'imobdesk-app-update-attempt'
/** Após o usuário clicar em Atualizar, não reexibe o dialog nesta sessão até a build bater. */
const UPDATE_DISMISSED_KEY = 'imobdesk-app-update-dismissed'
const UPDATE_SUPPRESS_MS = 60 * 60 * 1000

export function getCurrentAppBuildId(): string | null {
  return (
    document
      .querySelector(`meta[name="${META_NAME}"]`)
      ?.getAttribute('content')
      ?.trim() ?? null
  )
}

export async function fetchLatestAppBuildId(): Promise<string | null> {
  try {
    const response = await fetch(`/index.html?_=${Date.now()}`, {
      cache: 'no-store',
      headers: {
        Accept: 'text/html',
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    })

    if (!response.ok) return null

    const html = await response.text()
    const match = html.match(
      /<meta\s+name=["']app-build-id["']\s+content=["']([^"']+)["']/i,
    )

    return match?.[1]?.trim() ?? null
  } catch {
    return null
  }
}

export function markAppUpdateAttempt(): void {
  try {
    sessionStorage.setItem(UPDATE_ATTEMPT_KEY, String(Date.now()))
    sessionStorage.setItem(UPDATE_DISMISSED_KEY, '1')
  } catch {
    // ignore
  }
}

export function shouldSuppressAppUpdateNotification(): boolean {
  try {
    if (sessionStorage.getItem(UPDATE_DISMISSED_KEY) === '1') return true

    const raw = sessionStorage.getItem(UPDATE_ATTEMPT_KEY)
    if (!raw) return false

    const attemptedAt = Number(raw)
    if (!Number.isFinite(attemptedAt)) return false

    return Date.now() - attemptedAt < UPDATE_SUPPRESS_MS
  } catch {
    return false
  }
}

export function clearAppUpdateAttempt(): void {
  try {
    sessionStorage.removeItem(UPDATE_ATTEMPT_KEY)
    sessionStorage.removeItem(UPDATE_DISMISSED_KEY)
  } catch {
    // ignore
  }
}

export async function hasNewAppBuildAvailable(): Promise<boolean> {
  const current = getCurrentAppBuildId()
  const latest = await fetchLatestAppBuildId()

  if (!current || !latest) return false

  if (current === latest) {
    clearAppUpdateAttempt()
    return false
  }

  if (shouldSuppressAppUpdateNotification()) return false

  return true
}
